import Header from '../components/Header';
import Footer from '../components/Footer';
import { localAttractions } from './localAttractions';
import { stayProperties } from './stayProperties';
import './ExplorePage.css';

const sections = Object.values(stayProperties).map(property => ({ ...property, intro: property.introduction }));

export default function ExplorePage() {
  return <>
    <Header homeHref="/" />
    <main id="main-content" className="explore-page" tabIndex={-1}>
      <div className="explore-page__intro"><p className="explore-page__eyebrow">MAKE THE MOST OF WHERE YOU ARE</p><h1>A little exploring goes a long way.</h1><p>Start with the places close to your stay, then let the day unfold at your own pace.</p></div>
      <div className="explore-page__sections">
        {sections.map(section => <section className="explore-page__section" key={section.id} aria-labelledby={`${section.id}-explore-title`}>
          {section.image ? <img src={`${process.env.PUBLIC_URL}/images/${section.image}`} alt={section.alt} loading="lazy" /> : <div className="property-photo-pending">Property photographs to follow</div>}
          <div className="explore-page__content"><p className="explore-page__eyebrow">EXPLORE {section.name.toUpperCase()}</p><h2 id={`${section.id}-explore-title`}>{section.name}</h2><p>{section.intro}</p><ul>{localAttractions[section.id].map(place => <li key={place.name}><div><h3>{place.name}</h3>{place.time && <span>{place.time}</span>}</div><a href={place.mapUrl} target="_blank" rel="noopener noreferrer">{place.linkText} <span aria-hidden="true">↗</span></a></li>)}</ul>{!localAttractions[section.id].length && <p>Ask your host for nearby attractions and local recommendations.</p>}</div>
        </section>)}
      </div>
    </main>
    <Footer />
  </>;
}
